import { FC } from 'react';

import { IoIosInformationCircle } from 'react-icons/io';

import { useTheme } from 'styled-components';

import { IHelperTextProps } from './types';
import { Container } from './styles';
import { Typography } from '../Typography';

export const HelperText: FC<IHelperTextProps> = ({
  children,
  isError,
  isDisabled,
}) => {
  const theme = useTheme();

  return (
    <Container>
      <IoIosInformationCircle
        size={16}
        color={
          isDisabled
            ? theme.neutral[600]
            : isError
            ? theme.red
            : theme.neutral[500]
        }
      />

      <Typography.Paragraph
        size="x-small"
        color={isDisabled ? 'neutral.600' : isError ? 'red' : 'neutral.400'}
      >
        {children}
      </Typography.Paragraph>
    </Container>
  );
};
